"use client";

import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { LogoCircle } from './LogoCircle';
import { SparkleIcon } from './SparkleIcon';

const LogoWithSparkle = () => {
  return (
    <Box 
      position="relative" 
      h={["48px", "58px", "70px"]} 
      w={["50px", "60px", "72px"]}
    >
      <LogoCircle />
      <Box
        position="absolute"
        top="2px"
        right="-2px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        p="4px"
        w={["20px", "24px", "28px"]}
        h={["20px", "24px", "28px"]}
        bg="white"
        borderRadius="full"
        borderWidth="1.167px"
        borderStyle="solid"
        borderColor="indigo.400"
      >
        <SparkleIcon />
      </Box>
    </Box>
  );
};

export default LogoWithSparkle; 